export const addMobilityTokenErrors: Record<string, string> = {
  ALREADY_EXISTS: 'mobilityTokenExists',
  INTERNAL_SERVER_ERROR: 'internalServerError',
};

export const editMobilityTokenErrors: Record<string, string> = {
  NOT_FOUND: 'mobilityTokenNotFound',
  INTERNAL_SERVER_ERROR: 'internalServerError',
};
